module.exports = __webpack_public_path__ + "static/silver_sol_malaria_the_indian_practitioner-05bf0d7831cb33bd5a8e15d6b4273875.pdf";